export default {
    player: {
        FEEDBACK: "Feedback",
        LISTEN_ON: "Listen on ",
        LISTEN_TO_THIS_ARTICLE: "Listen to this article",
        NOA: "Noa",
        SPEED: "Speed",
    },
};
